import { render, staticRenderFns } from "./DateEditor.vue?vue&type=template&id=b9c8c3ce&"
import script from "./DateEditor.vue?vue&type=script&lang=js&"
export * from "./DateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports